import React from 'react'
import { useSessionMonitor } from '../hooks/useSessionMonitor'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faShieldHalved } from '@fortawesome/free-solid-svg-icons'

const RING_RADIUS = 20
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS
const TOTAL_WARNING_SECONDS = 120

const SessionExpiryWarning: React.FC = () => {
    const { showWarning, secondsRemaining, extendSession } =
        useSessionMonitor()

    if (!showWarning || secondsRemaining <= 0) return null

    const progress = secondsRemaining / TOTAL_WARNING_SECONDS
    const strokeDashoffset = RING_CIRCUMFERENCE * (1 - progress)
    const minutes = Math.floor(secondsRemaining / 60)
    const seconds = secondsRemaining % 60
    const timeDisplay = `${minutes}:${seconds.toString().padStart(2, '0')}`
    const isUrgent = secondsRemaining <= 30

    return (
        <div
            className={`session-expiry-warning ${isUrgent ? 'session-expiry-warning--urgent' : ''}`}
        >
            <div className="session-expiry-warning__glow" />

            <div className="session-expiry-warning__content">
                <div className="session-expiry-warning__timer">
                    <svg
                        width="52"
                        height="52"
                        viewBox="0 0 52 52"
                        className="session-expiry-warning__ring"
                    >
                        <circle
                            cx="26"
                            cy="26"
                            r={RING_RADIUS}
                            fill="none"
                            stroke="rgba(255,255,255,0.15)"
                            strokeWidth="3"
                        />
                        <circle
                            cx="26"
                            cy="26"
                            r={RING_RADIUS}
                            fill="none"
                            stroke={isUrgent ? '#ef4444' : '#f59e0b'}
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeDasharray={RING_CIRCUMFERENCE}
                            strokeDashoffset={strokeDashoffset}
                            transform="rotate(-90 26 26)"
                            className="session-expiry-warning__ring-progress"
                        />
                    </svg>
                    <span className="session-expiry-warning__time">
                        {timeDisplay}
                    </span>
                </div>

                <div className="session-expiry-warning__info">
                    <div className="session-expiry-warning__title">
                        <FontAwesomeIcon
                            icon={faClock}
                            className="session-expiry-warning__icon"
                        />
                        Session expiring
                    </div>
                    <div className="session-expiry-warning__subtitle">
                        You'll be locked out soon
                    </div>
                </div>

                <button
                    className="session-expiry-warning__extend-btn"
                    onClick={extendSession}
                    type="button"
                >
                    <FontAwesomeIcon icon={faShieldHalved} />
                    <span>Extend</span>
                </button>
            </div>
        </div>
    )
}

export default SessionExpiryWarning
